import { Component } from "react";
import Form from "react-jsonschema-form";
import { connect } from "react-redux";
import { ErrorView } from "common/components/error";

import { CommentsRedux } from "./comments";

import { TextareaMD } from "./widgets/textareaMD";
import { TypeAheadPicker } from "./widgets/picker";
import { FileUploader } from "./widgets/uploader";

const mapStateToProps = (state) => ({
    currentUser: state.common.user.username
});
const mapDispatchToProps = {};
const mergeProps = null;
const options = {
    forwardRef: true
};

class ReportForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            formData: {},
            loaded: false,
            has_error: false
        };
    }

    componentDidMount() {
        if (this.props.itemId === "new") {
            this.setState({
                formData: {},
                loaded: true
            });
        } else if (!this.state.loaded) {
            this.setState({
                loading: true
            });
            if (typeof this.props.fetchReportForm() !== "undefined") {
                this.fetchReportForm();
            }
        }
    }
    
    fetchReportForm = () => {
        this.props.fetchReportForm().then((data) => {
            Object.keys(data).forEach((field) => {
                if (data[field] === null) {
                    delete data[field];
                }
            });
            this.setState(() => ({
                formData: data,
                loaded: true
            }));
        }, (error) => {
            this.setState(() => ({
                has_error: true
            }));
  
            // Not sure why we return resolved promise here, but keep it here just in case
            // eslint-disable-next-line promise/no-return-wrap
            // Let's see waht happens if we don't return promise
            return error;
        }).finally(() => {
            this.setState(() => ({
                loading: false,
                loaded: true
            }));
        });
    };

    renderForm() {
        if (this.state.loading) {
            return (
                <div className="report-form">
                    <div className="loader text-input__loading--line medium"/>
                    <div className="loader text-input__loading--line long"/>
                </div>
            );
        }
        if (this.state.has_error) {
            return (
                <div className="report-form">
                    <ErrorView message="There was an error fetching report form data" header="Error" custom />
                </div>
            );
        }
        return (
            <Form
                noValidate
                schema={this.props.meta?.schema || {}}
                uiSchema={this.props.meta?.uiSchema || {}}
                widgets={{
                    TextareaWidget: TextareaMD,
                    TypeAheadPicker
                }}
                fields={{
                    FileUploader
                }}
                formData={this.state.formData}
                onSubmit={this.props.handleSubmitForm}
                className="report-form"
                ref={this.props.formRef}
            >
                {(!this.props.hideActions
                  && (
                  <div className="actions">
                      <button
                          type="button"
                          onClick={this.props.handleCancelForm()}
                          className="pz-icon-text-button action-button"
                      >Close
                      </button>
                      <button type="submit" className="pz-icon-text-button action-button">{this.props.itemId === "new" ? "Create" : "Update"}</button>
                  </div>
                  ))
                 || (<div className="actions"/>)}
            </Form>
        );
    }

    render() {
        return (
            <div className={`comments-${this.props.meta?.has_comments}`}>
                {this.renderForm()}
                {this.props.meta?.has_comments
                && <CommentsRedux className="comments-box" reportId={this.props.id} itemId={this.props.itemId} />}
            </div>
        );
    }
}

export const ReportFormRedux = connect(mapStateToProps, mapDispatchToProps, mergeProps, options)(ReportForm);
